import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=169bedc6&scoped=true&"
import script from "./accounts.vue?vue&type=script&lang=js&"
export * from "./accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169bedc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/nico/Projects/ecopbx-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VContainer,VDataTable,VFlex,VIcon,VLayout,VSpacer,VToolbar})
